import React, {Component, Fragment, useState, useEffect} from 'react'
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux"
import toast, { Toaster } from 'react-hot-toast'
import useMediaQuery from "./utilities/useMediaQuery"

import styles from './uetheme.scss'
import './MainApp.scss'

import Navbar from "./Layout/Navbar"
import BaseMap from "./Layout/BaseMap"
import SideZone from "./Layout/SideZone"
import MobileFooter from "./Layout/MobileFooter";
import UserState from "./Layout/UserState"
import Notifications from "./notifications/Notifications"
import ProprietaireListParcelles from "./Layout/ProprietaireListParcelles"
import HistoriqueListParcelles from "./Layout/HistoriqueListParcelles"
import Pricing from "./Layout/Pricing";
import MainStore from "../store/MainStore"
import CenterMainSection from "./Layout/CenterMainSection"
import moment from "moment"
import FilterTools from "./searchTool/FilterTools";

const mainStore = MainStore //createStore(RootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() );

const MainApp = (props)=>{

    const [theme, setTheme] = useState('dark');
    const [notifications, setNotification] = useState(props.notifications)
    const [localisation, setLocalisation] = useState(props.localisation)
    const [purchaseInfo, setPurchaseInfo] = useState();//{id:'SWY_12135464', description: 'test test', amount_total: '499', payment_status: 'OK', customer_email:'me@me.com'});
    const [ignKey, setIgnKey] = useState(props.ignkey);
    const [geoServerUrl , setGeoServerUrl ] = useState(props.geoserver)
    const [mouseX , setMouseX ] = useState()
    let state = MainStore.getState()
    const [ueFloatingDisplayZone, setUeFloatingDisplayZone] = useState({
        "width": "100%",
        "height": "100%",
        "position" : "fixed",
        "top" : "100px",
        "left": "60px",
    })

    useEffect(()=>{
        $(function () {
            $('[data-toggle="tooltip"]').tooltip({placement: 'right', html: true, trigger: 'hover'})
            moment.locale('fr');
        });
        (props.ui_theme)?setTheme(props.ui_theme):null;//from php

        // Parse purchase_info if it exists
        if (props.purchase_info) {
            try {
                const parsedInfo = JSON.parse(props.purchase_info);
                setPurchaseInfo(parsedInfo);
            } catch (error) {
                console.error('Failed to parse purchase_info:', error);
            }
        }
    }, [])

    useEffect(()=>{
        (theme)?document.cookie = "uetheme="+theme+";expires=Wed, 15 Jan 2030 12:00:00 UTC":null;
    }, [theme])

    useEffect(() => {
        if (purchaseInfo) {
            // Display the thank you pop-up with a close button
            toast.success(
                (t) => (
                    <div>
                        <h3>Félicitations</h3>
                        <h5>Bienvenue chez Urba Earth !</h5>
                        <p className='mt-4'>Votre commande a bien été prise en compte.</p>
                        <p>Un email contenant tous les détails vient d'être envoyé à {purchaseInfo.customer_email}.</p>
                        <div className='d-flex justify-content-center' style={{paddingRight: '20px'}}>
                            <button
                                onClick={() => toast.dismiss(t.id)}
                                className='btn btn-primary'
                                style={{
                                    marginTop: '15px',
                                    padding: '10px 20px',
                                
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                }}
                            >
                                Fermer
                        </button>
                        </div>
                        
                    </div>
                ),
                {
                    duration: 50000, // Duration in milliseconds
                    position: 'top-center',
                    style: {
                        padding: '20px',
                        borderRadius: '10px',
                        background: '#333',
                        color: '#fff',
                    },
                }
            );
        }
    }, [purchaseInfo]);

    const updateTheme = (ui)=>{
       (ui && theme==='light')?setTheme("dark"):setTheme("light");
    }

    return (
        <div className={`MainApp ${theme}`}>
            <Navbar filtertools={'ok'} updateTheme={updateTheme} theme={theme}/>
            <MobileFooter />
            <ProprietaireListParcelles />
            <HistoriqueListParcelles />
            <Pricing />
            <div id="maincontainer" className="container-fluid">
                <SideZone />
                <div id="main">
                    <div className="container-bad">
                        <UserState />
                        <BaseMap  id="baseMAp" localisation={localisation} ignkey={ignKey} geoserverurl={geoServerUrl}/>
                        <FilterTools id={'filtertool'} />
                       {/* <Notifications id="notifications"  unread={notifications} />*/}
                    </div>
                </div>
            </div>

           <CenterMainSection/>

            <Toaster
                position="top-right"
                toastOptions={{
                    style: {
                        top: '100px',
                        margin: '90px',
                        zIndex: '100000'
                    }
                }}
            />
        </div>
    );
}

export default MainApp;



if (document.getElementById('mainApp')) {

    const element = document.getElementById('mainApp')
    const props = Object.assign({}, element.dataset)

    ReactDOM.render(
        <Provider store={mainStore}>
            <BrowserRouter>
                <MainApp {...props}/>
            </BrowserRouter>
        </Provider>
        , document.getElementById('mainApp'));
}
